import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EformAvisLiesType} from '../../../models/enum/eformAvisLiesType';
import {CanNavigateInStepperService} from '../../../services/can-navigate-in-stepper.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup} from '@angular/forms';
import {TableauMessages} from '../../../models/component-messages/tableau-messages';
import {InformationComponent} from '../../../modals/information/information.component';
import {LogService} from '../../../services/log.service';
import { TableActionService } from '../tableau/services/table.action.service';
import {AuthorizationService} from '../../../../../authorization/services/authorization.service';
import {EnumMicroDroits} from '../../../../administration/models/micro.droits';
import {first} from 'rxjs/operators';
import { StatutAvisEnum } from '../../../../../models/enums/statut-avis.enum';


@Component({
  selector: 'app-tableau-action',
  templateUrl: './tableauAction.component.html',
  styleUrls: ['./tableauAction.component.scss']
})
export class TableauActionComponent implements OnInit {

  private LOG: LogService = new LogService(TableauActionComponent);

  public formChecked = '';
  public dataRows: FormGroup = new FormGroup({});
  public tableauMessage = new TableauMessages();
  hasManageRight: boolean;
  hasViewingRight: boolean;


  @Input() colActions : any;
  @Input() element : any = [];
  @Input() liables: any;
  @Input() reliables: any;
  @Input() canBeLier: any;
  @Output() tabActionEvent: EventEmitter<any> = new EventEmitter();

  constructor(private canNavigateInStepperService: CanNavigateInStepperService,
              private modalService: NgbModal, public tableActionService : TableActionService,
              private authorizationService: AuthorizationService) {
  }

  ngOnInit(): void {
    this.habilitations();
  }

  ngOnDestroy(): void {
    this.tableActionService.liables.next([]);
    this.tableActionService.reliables.next([]);
  }


  changeDisplay(action, element): boolean{
    let changeHidden : boolean = false;
    //Le statut de l’avis doit être « Publié »
    //L’intitulé du formulaire ne doit pas contenir les intitulés « |  Avis annulé» ou « | Intention d’annuler »
    if (action.type == 'change' && (
      (element['statut'] !== 'PUBLIE' && element['statut'] !== 'IMPORTE') || !element['formulairecode'].includes('E_FORM')
      || element['motif']?.includes("cancel")
      || !this.canBeLier)){
        changeHidden = true;
    }
    return changeHidden;
  }

  /**
   * Méthode permettant de savoir quel action doit être caché
   *
   * @param action Action à vérifier
   * @param element Element sur lequel l'action est appliquée
   * @param canBeLier
   * @param reliables
   * @returns
   */
  shouldHideAction(action: any, element: any, canBeLier: boolean, reliables: any[]): boolean {
    const statut = element['statut'] as StatutAvisEnum;

    const isNotElabore = statut !== StatutAvisEnum.ELABORE;
    const isNotImporte = statut !== StatutAvisEnum.IMPORTE;
    const isNotPublieOrImporte = statut !== StatutAvisEnum.PUBLIE && statut !== StatutAvisEnum.IMPORTE;
    const isNotEnvoyeRefuseOrNonConforme = statut !== StatutAvisEnum.ENVOYE && statut !== StatutAvisEnum.REFUSE && statut !== StatutAvisEnum.EN_COURS;
    const isNotBoampValid = !element['urlBoamp'] || statut !== StatutAvisEnum.PUBLIE;

    switch (action.type) {
      case 'Editer':
        return isNotElabore && statut !== StatutAvisEnum.EN_COURS;
      case 'Supprimer':
        return isNotElabore && statut !== StatutAvisEnum.EN_COURS && isNotImporte;

      case 'Declarer':
        return !canBeLier || !this.isInitial(element) || isNotPublieOrImporte;

      case 'Annuler':
      case 'Rectifier':
        return isNotPublieOrImporte || !canBeLier || this.isEform(element) || !this.isInitialOrAttrib(element);

      case 'Lier':
        return isNotElabore || reliables.length === 0 || element.isLie;

      case 'boamp':
        return isNotBoampValid;

      case 'TéléchargerXML':
        return isNotEnvoyeRefuseOrNonConforme;

      case 'Télécharger':
      case 'Visualiser':
        return statut === StatutAvisEnum.IMPORTE;

      case 'Corriger':
        return element['statut'] !== StatutAvisEnum.REFUSE || !canBeLier;

      case 'LierConsultationPlace':
        return false;

      default:
        break;
    }

    return (
      this.changeDisplay(action, element) ||
      this.eformAvisLiesDisplay(action, element) ||
      (!this.hasManageRight && action.type !== 'Visualiser' && action.type !== 'Télécharger' && action.type !== 'boamp') ||
      !this.hasViewingRight
    );
  }

  eformAvisLiesDisplay(action,element): boolean{
    let hide : boolean = false;

    //Le statut de l’avis doit être « Publié »
    //On regarde dans le referentielEformAvisLies pour savoir quel bouton afficher par rapport au type de formulaire
    if ((action.type === EformAvisLiesType.CONCURRENCE || action.type === EformAvisLiesType.CONCURRENCE_ASSOUPLI || action.type === EformAvisLiesType.RESULTAT || action.type === EformAvisLiesType.MODIF_MARCHE)
      && (element['statut'] !== 'PUBLIE' && element['statut'] !== 'IMPORTE' || !element['formulairecode'].includes('E_FORM') || !this.canNavigateInStepperService.referentielEformAvisLies)) {
      hide = true
    } else {
      const buttonToDisplay = this.canNavigateInStepperService.referentielEformAvisLies?.filter(e => e.form === element['formulairecode']).map(e => e.typeAvisLies);
      switch (action.type) {
        case EformAvisLiesType.CONCURRENCE:
          if (!buttonToDisplay.includes(EformAvisLiesType.CONCURRENCE) || !this.canBeLier) {
            hide = true;
          }
          break;

        case EformAvisLiesType.CONCURRENCE_ASSOUPLI:
          if(!buttonToDisplay.includes(EformAvisLiesType.CONCURRENCE_ASSOUPLI) || !this.canBeLier){
            hide = true;
          }
          break;

        case EformAvisLiesType.RESULTAT:
          if(!buttonToDisplay.includes(EformAvisLiesType.RESULTAT) || !this.canBeLier){
            hide = true;
          }
          break;

        case EformAvisLiesType.MODIF_MARCHE:
          if(!buttonToDisplay.includes(EformAvisLiesType.MODIF_MARCHE) || !this.canBeLier){
            hide = true;
          }
          break;

        default:
          break;
      }

  }
    return hide;
  }
  public getEvent(event, element, id,liables,reliables) {
    this.formChecked = element.enum;
    if ((id === 'INPUT_1' || id === 'INPUT_7') && !element.formulairecode) {
      const value = ((this.dataRows.controls[element.id] as FormGroup).controls.checked as FormGroup).value;
      const keys = Object.keys(((this.dataRows.controls[element.id] as FormGroup).controls.children as FormGroup).controls);
      for (const key of keys) {
        (((this.dataRows.controls[element.id] as FormGroup).controls.children as FormGroup).controls[key] as FormGroup).controls.checked.setValue(value);
      }
    }

    if (event.type === 'Information') {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = element.intitule;
      modalRef.componentInstance.contentTitle = this.tableauMessage.contentTitle;
      modalRef.componentInstance.content = element.description;
      modalRef.componentInstance.footerTitle = this.tableauMessage.footerTitle;
      modalRef.componentInstance.url = element.url;
      modalRef.componentInstance.link = 'Description de l\'' + element.intitule + ' sur le site du BOAMP';
    }

    this.tabActionEvent.emit({ action: event, data: element,liables,reliables});
  }
  isInitial(type){
    return type?.formulairecode?.includes('IN');
  }

  isInitialOrAttrib(type){
    return type?.formulairecode?.includes('IN') || type?.formulairecode?.includes('AT');
  }

  isEform(type){
  return (type['formulairecode'].startsWith("E_"));
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn(Array.of(EnumMicroDroits.AVIS_PUBLICITE_GESTION))
      .pipe(first())
      .subscribe(hasManageRight => { this.hasManageRight = hasManageRight });

    this.authorizationService.hasAnyMicroRightIn(Array.of(EnumMicroDroits.AVIS_PUBLICITE_CONSULTATION, EnumMicroDroits.AVIS_PUBLICITE_GESTION))
      .pipe(first())
      .subscribe(hasViewingRight => { this.hasViewingRight = hasViewingRight });

  }
}


